import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  CloseButton,
} from "react-bootstrap";
import CustomNavbar from "../../../../components/CustomNavbar";
import SidebarClimate from "../../../../components/Clima/SidebarClimate";
import messages from "../../../../redux/messages";
import { getCategory } from "../../../../redux/climalaboral/category/actions";
import CustomPagint from "../../../../components/CustomPagint";
import ModalNewCuestionaire from "../../../../components/Clima/ModalNewCuestionaire";
import {
  clonePlantillaCuestionario,
  deletePlantillaCuestionarios,
  getPlantillaCuestionarios,
  getPlantillaCuestionariosImport,
  savePlantillaCuestionariosImport,
} from "../../../../redux/climalaboral/plantillaCuestionario/action";

const Plantillas = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [offsetImport, setOffsetImport] = useState(0);
  const [limitImport, setLimitImport] = useState(10);
  const [currentPageImport, setCurrentPageImport] = useState(1);
  const [filterImport, setFilterImport] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalPlantilla, setShowModalPlantilla] = useState(false);

  const [show, setShow] = useState(false);
  //Redux
  const dispatch = useDispatch();
  const history = useHistory();

  const userRoles = useSelector((store) => store.auth.userRoles);

  const {
    surveyLoading,
    surveyTemplate,
    surveyTemplateFail,

    // Para Modal import cuestionario
    surveyImportLoading,
    surveyTemplateImport,
    surveyTemplateImportFail,
    saveLoaderImport,
    formImportError,
  } = useSelector((store) => store.plantillaCuestionario);

  const pages = Math.ceil(
    surveyLoading && surveyLoading.count > 0
      ? surveyLoading.count > 0 / limit
      : 0
  );

  const pagesSurveyImport = Math.ceil(
    surveyTemplateImport && surveyTemplateImport.count > 0
      ? surveyTemplateImport.count > 0 / limit
      : 0
  );

  const _getPlantillaCuestionarios = (
    offs = offset,
    lim = limit,
    filt = filter
  ) =>
    dispatch(
      getPlantillaCuestionarios({
        offset: offs,
        limit: lim,
        filter: filt,
      })
    );

  const _getPlantillaCuestionariosImport = (
    offs = offsetImport,
    lim = limitImport,
    filt = filterImport
  ) =>
    dispatch(
      getPlantillaCuestionariosImport({
        offset: offs,
        limit: lim,
        filter: filt,
      })
    );

  useEffect(() => {
    _getPlantillaCuestionarios();
    _getPlantillaCuestionariosImport();
    dispatch(getCategory({}));
  }, []);

  const onAddNewcuestionaire = () => {
    setShowModal(true);
  };

  const onAddTemplate = (item, index) => {
    setShowModalPlantilla(true);
  };

  const importarPreguntas = (item) => {
    const req = {
      id: item.id,
    };
    dispatch(savePlantillaCuestionariosImport(req, setShowModalPlantilla));
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPlantillaCuestionarios(oOffset, limit, e.target.filter.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPlantillaCuestionarios(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      setOffsetImport(0);
      setFilterImport("");
      dispatch(
        deletePlantillaCuestionarios(
          id,
          index,
          _getPlantillaCuestionariosImport,
          limitImport
        )
      );
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarClimate show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Cuestionarios</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle mx-2"
                      onClick={() => onAddTemplate()}
                      disabled={
                        !surveyTemplate ||
                        (surveyTemplate && surveyTemplate.count === 0)
                          ? true
                          : false
                      }
                    >
                      <i className="material-icons">article</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAddNewcuestionaire()}
                    >
                      <i className="material-icons">post_add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          {surveyLoading ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              {!!surveyTemplateFail && (
                <Alert variant="danger" className="mt-4 mb-1 mx-3">
                  {surveyTemplateFail}
                </Alert>
              )}
              {surveyTemplate && surveyTemplate.count > 0 ? (
                <>
                  <Row className="px-2">
                    {surveyTemplate.data.map((item, index) => (
                      <Col md="3" className="mb-2">
                        {/* <Card className="shadow-sm bg-white rounded h-100"> */}
                        <Card className="shadow-sm bg-white rounded">
                          <Card.Header
                            className="d-flex flex-wrap justify-content-between align-items-between text-justify btn-primary buttonHeader"
                            disabled
                          >
                            <Col
                              xs="10"
                              sm="10"
                              md="10"
                              lg="10"
                              xl="10"
                              style={{
                                paddingLeft: "0",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.nombre}
                            </Col>
                            {userRoles.length > 0 &&
                            userRoles.find(
                              (opt) =>
                                opt.toString().toLowerCase() === "administrador"
                            ) !== undefined ? (
                              <CloseButton
                                className="buttonClose"
                                onClick={() => onDelete(item.id, index)}
                                variant="white"
                              />
                            ) : null}
                          </Card.Header>
                          <Card.Body
                            className="flex-wrap justify-content-center align-items-center text-justify"
                            style={{
                              height: "160px",
                              overflow: "auto",
                            }}
                          >
                            <Card.Text>{item.descripcion}</Card.Text>
                          </Card.Body>
                          <Card.Footer
                            className="d-flex flex-wrap justify-content-center align-items-center"
                            style={{ borderTop: "1px solid #ced4da" }}
                          >
                            <Card.Link
                              className="btn btn-primary m-auto"
                              onClick={() =>
                                history.push(
                                  `/cuestionario/${
                                    item.id
                                  }/${item.nombre.replaceAll("/", "-")}`
                                )
                              }
                            >
                              <i className="material-icons">edit</i>
                            </Card.Link>
                          </Card.Footer>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={surveyTemplate ? surveyTemplate.count : 0}
                    pages={pages}
                    pagFunc={_getPlantillaCuestionarios}
                  />
                </>
              ) : (
                <Alert className="my-4" variant="info">
                  Aún no hay cuestionarios registrados, comience agregando
                  algunos.
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      <ModalNewCuestionaire showModal={showModal} setShowModal={setShowModal} />
      <Modal
        size="xl"
        show={showModalPlantilla}
        onHide={() => setShowModalPlantilla(false)}
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title>Importar preguntas</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "100%", overflowY: "auto" }}>
            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
              <h6 className="font-weight-bold text-uppercase">Cuestionarios</h6>
            </div>
            <div className="px-2">
              <hr />
            </div>
            {!!surveyTemplateImportFail && (
              <Alert variant="danger" className="mt-1 mb-3 mx-2">
                {surveyTemplateImportFail}
              </Alert>
            )}
            {!!formImportError && (
              <Alert variant="danger" className="mt-1 mb-3 mx-2">
                {formImportError}
              </Alert>
            )}
            <Row className="px-2">
              {surveyImportLoading ? (
                <div className="d-flex justify-content-center mt-4">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : (
                <>
                  {surveyTemplateImport && surveyTemplateImport.count > 0 ? (
                    <>
                      {surveyTemplateImport.data.map((item) => (
                        <>
                          <Col md="3" className="mb-2">
                            <Card
                              className="h-100 shadow-sm bg-white rounded"
                              style={{
                                cursor: "pointer",
                                opacity: saveLoaderImport ? "0.8" : "1",
                              }}
                              onClick={() => {
                                if (!saveLoaderImport) {
                                  importarPreguntas(item);
                                }
                              }}
                            >
                              <Card.Header
                                className="d-flex flex-wrap justify-content-center align-items-center text-justify btn-primary buttonHeader"
                                disabled
                              >
                                <Col
                                  xs="12"
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  xl="12"
                                  style={{
                                    paddingLeft: "0",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item.nombre}
                                </Col>
                              </Card.Header>
                              <Card.Body
                                className="flex-wrap justify-content-center align-items-center text-justify"
                                style={{ overflowY: "auto", height: "160px" }}
                              >
                                <Card.Text>{item.descripcion}</Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>
                        </>
                      ))}
                    </>
                  ) : (
                    <Col>
                      <Alert className="mt-1 mb-3" variant="info">
                        Aún no hay cuestionarios registrados, comience agregando
                        algunos.
                      </Alert>
                    </Col>
                  )}
                </>
              )}
            </Row>
            <>
              <CustomPagint
                limit={limitImport}
                setLimit={setLimitImport}
                offset={offsetImport}
                setOffset={setOffsetImport}
                currentPage={currentPageImport}
                setCurrentPage={setCurrentPageImport}
                dataLenght={
                  surveyTemplateImport ? surveyTemplateImport.count : 0
                }
                pages={pagesSurveyImport}
                pagFunc={_getPlantillaCuestionariosImport}
              />
            </>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Plantillas;
